import { render, staticRenderFns } from "./personal-user-info.vue?vue&type=template&id=c4802658&"
import script from "./personal-user-info.vue?vue&type=script&lang=js&"
export * from "./personal-user-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/administracion-frontend/administracion-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4802658')) {
      api.createRecord('c4802658', component.options)
    } else {
      api.reload('c4802658', component.options)
    }
    module.hot.accept("./personal-user-info.vue?vue&type=template&id=c4802658&", function () {
      api.rerender('c4802658', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/components/admin-personal/personal-profile-full/personal-user-info/personal-user-info.vue"
export default component.exports